import axios from 'axios';
let instance = null;
export default class RESTService {
	constructor() {
		if (!instance) {
			instance = this;
		}
		return instance;
	}

	setAuthorizationToken(token) {
		if (token) {
			this.token = token;
			axios.defaults.headers.common['authorization'] = `bearer ${token}`;
		}
	}

	setRS(rs) {
		instance.rs = rs;
	}

	getLocationParams() {
		let RS = instance.rs;
		return `?tenant=${RS.getCurrentTenant()}${RS.getCurrentEnvironment() ? `&environment=${RS.getCurrentEnvironment()}` : ''}`;
	}

	getAppDefs() {
		return axios.get(`/madcloud/api/app-definition/getDefinitions`);
	}

	getInstallableApps() {
		return axios.get(`/madcloud/api/app-definition/getInstallableApps`);
	}

	saveAppDef(definition) {
		return axios.post(`/madcloud/api/app-definition/saveDefinition`, definition);
	}

	updateAppDef(definition) {
		return axios.post(`/madcloud/api/app-definition/updateDefinition`, definition);
	}

	updateAppConfigSegment(path, value, app) {
		let RS = instance.rs;
		return axios.post(`/madcloud/api/app-definition/updateConfiguration${this.getLocationParams()}`, {
			app: app ? app : RS.getCurrentApplication(),
			path: path,
			value: value
		});
	}

	migrateAppConfigNode(path, value, app, tenant, environment) {
		let RS = instance.rs;
		return axios.post(`/madcloud/api/app-definition/updateConfiguration?tenant=${tenant}&environment=${environment}`, {
			app: app ? app : RS.getCurrentApplication(),
			path: path,
			value: value
		});
	}

	deleteAppDef(definition) {
		return axios.post(`/madcloud/api/app-definition/deleteDefinition`, definition);
	}

	installAppDef(definition) {
		return axios.post(`/madcloud/api/app-definition/installDefinition${this.getLocationParams()}`, definition);
	}

	deleteAppConfiguration(app) {
		return axios.post(`/madcloud/api/app-definition/deleteConfiguration${this.getLocationParams()}`, app);
	}

	getAppConfig(definition) {
		return axios.post(`/madcloud/api/app-definition/getConfiguration${this.getLocationParams()}`, definition);
	}

	createTenant(tenant) {
		return axios.post('/madcloud/api/tenants/createTenant', tenant);
	}

	getTenants() {
		return axios.get('/madcloud/api/tenants/getTenants');
	}

	getTenantByName(name) {
		return axios.get('/madcloud/api/tenants/getTenantByName?name=' + encodeURIComponent(name));
	}

	getTenantEnvironments(name) {
		return axios.get('/madcloud/api/tenants/getTenantEnvironments?tenant=' + name);
	}

	updateEnvironment(env) {
		return axios.post(`/madcloud/api/tenants/updateEnvironment${this.getLocationParams()}`, env);
	}

	createEnvironment(env) {
		return axios.post(`/madcloud/api/tenants/createEnvironment${this.getLocationParams()}`, env);
	}

	deleteEnvironment() {
		return axios.get(`/madcloud/api/tenants/deleteEnvironment${this.getLocationParams()}`);
	}

	getConnections() {
		return axios.get(`/madcloud/api/connections/getConnections${this.getLocationParams()}`);
	}

	createConnection(connection) {
		return axios.post(`/madcloud/api/connections/createConnection${this.getLocationParams()}`, connection);
	}

	updateConnection(connection) {
		return axios.post(`/madcloud/api/connections/updateConnection${this.getLocationParams()}`, connection);
	}

	deleteConnection(name) {
		return axios.post(`/madcloud/api/connections/deleteConnection${this.getLocationParams()}`, { name: name });
	}

	testConnection(data) {
		return axios.post(`/madcloud/api/connections/testConnection${this.getLocationParams()}`, data);
	}

	getEndpoints() {
		return axios.get(`/madcloud/api/endpoints/getEndpoints${this.getLocationParams()}`);
	}

	createEndpoint(endpoint) {
		return axios.post(`/madcloud/api/endpoints/createEndpoint${this.getLocationParams()}`, endpoint);
	}

	updateEndpoint(endpoint) {
		return axios.post(`/madcloud/api/endpoints/updateEndpoint${this.getLocationParams()}`, endpoint);
	}

	deleteEndpoint(name) {
		return axios.post(`/madcloud/api/endpoints/deleteEndpoint${this.getLocationParams()}`, { name: name });
	}

	clearEndpointCache(endpoint) {
		return axios.get(`/madcloud/api/endpoints/clearCache${this.getLocationParams()}&endpoint=${encodeURIComponent(endpoint)}`);
	}

	testEndpoint(endpoint, headers) {
		return axios.post(`/madcloud/api/endpoints/testEndpoint${this.getLocationParams()}`, endpoint, headers);
	}

	asyncEndpoint(ticketId) {
		return axios.get(`/madcloud/api/endpoints/asyncEndpoint${this.getLocationParams()}&ticketId=${ticketId}`);
	}

	getAgents() {
		return axios.get(`/madcloud/api/agents/getAgents${this.getLocationParams()}`);
	}

	getAgentConfig(agent) {
		return axios.get(`/madcloud/api/agents/getAgentConfig${this.getLocationParams()}&agent=${encodeURIComponent(agent)}`);
	}

	createAgent(agent) {
		return axios.post(`/madcloud/api/agents/createAgent${this.getLocationParams()}`, agent);
	}

	removeAgent(agent) {
		return axios.get(`/madcloud/api/agents/removeAgent${this.getLocationParams()}&agent=${agent}`);
	}

	pingAgent(agent) {
		return axios.post('/madcloud/api/agents/ping', agent);
	}

	getToAlert() {
		return axios.get(`/madcloud/api/agents/getToAlert${this.getLocationParams()}`);
	}

	updateAlerts(emails) {
		return axios.post(`/madcloud/api/agents/updateAlerts${this.getLocationParams()}`, emails);
	}

	/*Entities Routes*/
	getEntities() {
		return axios.get(`/madcloud/api/entities/getEntities${this.getLocationParams()}`);
	}

	createEntity(entity) {
		return axios.post(`/madcloud/api/entities/createEntity${this.getLocationParams()}`, entity);
	}

	deleteEntity(entity) {
		return axios.get(`/madcloud/api/entities/deleteEntity${this.getLocationParams()}&entity=${entity}`);
	}

	publishGraph() {
		return axios.get(`/madcloud/api/entities/publishGraph${this.getLocationParams()}`);
	}

	updateEntity(entity) {
		return axios.post(`/madcloud/api/entities/updateEntity${this.getLocationParams()}`, entity);
	}

	getResolvers() {
		return axios.get(`/madcloud/api/entities/getResolvers${this.getLocationParams()}`);
	}

	createResolver(resolver) {
		return axios.post(`/madcloud/api/entities/createResolver${this.getLocationParams()}`, resolver);
	}

	updateResolver(resolver) {
		return axios.post(`/madcloud/api/entities/updateResolver${this.getLocationParams()}`, resolver);
	}

	deleteResolver(resolver) {
		return axios.get(`/madcloud/api/entities/deleteResolver${this.getLocationParams()}&resolver=${resolver}`);
	}

	getMutators() {
		return axios.get(`/madcloud/api/entities/getMutators${this.getLocationParams()}`);
	}

	createMutator(mutator) {
		return axios.post(`/madcloud/api/entities/createMutator${this.getLocationParams()}`, mutator);
	}

	updateMutator(mutator) {
		return axios.post(`/madcloud/api/entities/updateMutator${this.getLocationParams()}`, mutator);
	}

	deleteMutator(mutator) {
		return axios.get(`/madcloud/api/entities/deleteMutator${this.getLocationParams()}&mutator=${mutator}`);
	}

	graphQuery(query) {
		let RS = instance.rs;
		let url = process.env.SERVER_NAME;
		return axios.post(
			`https://${RS.getCurrentTenant()}.${url}/api/v2/global/${RS.getCurrentEnvironment()}/${RS.getCurrentTenant()}/graph`,
			query
		);
	}

	getMyUsers() {
		return axios.get(`/madcloud/api/users/getMyUsers`);
	}

	getAllRoles() {
		return axios.get(`/madcloud/api/users/getAllRoles`);
	}

	getMyProfile() {
		return axios.get('/madcloud/api/users/getMyProfile');
	}

	storeUserProfile(profileData) {
		return axios.post('/madcloud/api/users/storeUserProfile', profileData);
	}

	getMyPermissions() {
		return axios.get('/madcloud/api/users/getMyPermissions');
	}

	getMyActivity() {
		return axios.get('/madcloud/api/users/getMyActivity');
	}

	updateUserPassword(data) {
		return axios.post('/madcloud/api/users/updateUserPassword', data);
	}

	getIDPconfig() {
		return axios.get(`/madcloud/api/idp/getConfig${this.getLocationParams()}&app=concierge`);
	}

	login(email, password, method) {
		return axios.post('/madcloud/api/auth/login', { email, password, method, scope: 'madcloud' });
	}

	sendInvite(invite) {
		return axios.post(`/madcloud/api/auth/sendInvite`, invite);
	}

	getToken(code) {
		return axios.post('/madcloud/api/auth/token', { code });
	}

	password(email, password, token) {
		return axios.post('/madcloud/api/auth/password', { email, password, token });
	}

	signup(data) {
		return axios.post('/madcloud/api/auth/signup', data);
	}

	updateUser(user) {
		return axios.post('/madcloud/api/auth/updateUser', user);
	}
}



// WEBPACK FOOTER //
// ./src/services/RESTService.js